<template>
  <div class="mainContainer" v-loading="importLoading">
    <div class="nav">
      <el-form :model="searchForm" label-width="120px" :inline="true">
        <el-form-item label="供应商：">
          <el-input v-model="searchForm.supplierName" size="mini" placeholder="请输入供应商" />
        </el-form-item>
        <el-form-item label="结算类型：">
          <el-select v-model="searchForm.settlementType" size="mini" filterable style="width: 100%" placeholder="请选择结算类型" value-key="id">
            <el-option v-for="item in settlementTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="港口/库房名称：">
          <el-input v-model="searchForm.name" size="mini" placeholder="请输入港口/库房名称" />
        </el-form-item>
        <el-form-item label="作业类型：">
          <el-input v-model="searchForm.taskType" size="mini" placeholder="请输入作业类型" />
        </el-form-item>
        <el-form-item label="结算方式：">
          <el-select v-model="searchForm.contractType" size="mini" filterable style="width: 100%" placeholder="请选择结算类型" value-key="id">
            <el-option v-for="item in contractTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="状态：">
          <el-select v-model="searchForm.status" size="mini" filterable style="width: 100%" placeholder="请选择状态" value-key="id">
            <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="录入人员:">
          <el-input placeholder="请输入录入人员" size="mini" v-model="searchForm.createByName"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
          <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
          <el-button size="small" class="searchBtn" @click="btnClick('add')">新增</el-button>
          <el-button size="small" class="searchBtn" @click="btnClick('batchEnable')">启用</el-button>
          <el-button size="small" type="danger" @click="onClickDeletes">批量删除</el-button>
          <el-button size="small" class="resetBtn" @click="onClickStops">批量停用</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-row>
      <el-col :span="24" style="text-align: end" class="exportButton">
        <div style="display: flex; justify-content: flex-end">
          <span @click="download">模板下载</span>
          <batch-import :uploadUrl="uploadUrl" @importSuccess="searchBtn" @triggerLoading="importLoading = !importLoading" />
          <span class="mr0" @click="exportData">导出数据</span>
        </div>
      </el-col>
    </el-row>
    <div class="content">
      <el-table ref="registerTable" row-key="id" v-loading="tableLoading" :data="tableData" style="width: 100%" border :header-cell-style="headerCellStyle" @selection-change="selectionChange" :row-style="rowStyle">
        <el-table-column type="selection" align="center" min-width="50" />
        <el-table-column label="合同编号" prop="contractCode" align="center" min-width="200" />
        <el-table-column label="合同名称" prop="contractName" align="center" min-width="200" />
        <el-table-column label="供应商" prop="supplierName" align="center" min-width="240" />
        <el-table-column label="供应商类型" prop="supplierType" align="center" min-width="240">
          <template slot-scope="scope">
            <span>{{ scope.row.supplierType == 1 ? '公路' : scope.row.supplierType == 2 ? '水路' : scope.row.supplierType == 3 ? '港口及其他' : '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="结算类型" prop="settlementType" align="center" min-width="100" :formatter="settlementTypeFormat" />
        <el-table-column label="港口/库房名称" prop="name" align="center" min-width="120" />
        <el-table-column label="品牌" prop="brands" align="center" min-width="120" show-overflow-tooltip />
        <el-table-column label="作业类型" prop="taskType" align="center" min-width="120" />
        <el-table-column label="价格有效期" prop="date" align="center" width="200">
          <template slot-scope="scope"> {{ scope.row.startDate | validityDady }}--{{ scope.row.endDate | validityDady }} </template>
        </el-table-column>
        <el-table-column label="税率%" prop="taxRate" align="center" min-width="80" />
        <el-table-column label="合同单价" prop="contractPrice" align="center" min-width="100" />
        <el-table-column label="预结算单价" prop="preparePrice" align="center" min-width="100" />
        <el-table-column label="预估单价" prop="estimatePrice" align="center" min-width="100" />
        <el-table-column prop="createTime" label="创建时间" show-overflow-tooltip width="150" align="center">
          <template slot-scope="scope">{{ scope.row.createTime | getCreatTime }}</template>
        </el-table-column>
        <el-table-column prop="createByName" label="录入人员" show-overflow-tooltip width="150" align="center" />
        <el-table-column label="状态" prop="status" align="center" min-width="100" :formatter="statusFormat" />
        <el-table-column label="操作" width="360" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" class="searchBtn" @click="btnClick('info', scope.row)">详情 </el-button>
            <el-button size="mini" v-if="scope.row.status === 0" class="yellow-bg" @click="btnClick('edit', scope.row)">修改 </el-button>
            <!--            <el-button size="mini" class="yellow-bg" type="danger" @click="recordBtn(scope.row)" >补录合同</el-button>-->
            <!--            <el-button-->
            <!--              v-if="scope.row.status==1&&(scope.row.isPerfectPrice!=1||!scope.row.estimatePrice||scope.row.estimatePrice=='')"-->
            <!--              size='mini' class='yellow-bg' @click='btnClick("perfectPrice",scope.row)'>-->
            <!--              完善价格-->
            <!--            </el-button>-->
            <el-button size="mini" class="resetBtn" @click="btnClick('delete', scope.row)">删除 </el-button>
            <el-button size="mini" v-if="scope.row.status === 0" class="searchBtn" @click="btnClick('enable', scope.row)">启用 </el-button>
            <el-button size="mini" v-if="scope.row.status === 1" type="danger" @click="btnClick('disabled', scope.row)">停用 </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="paginationContainer">
        <el-pagination background :page-sizes="[10, 20, 30, 40]" layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="contractSizeChange" @current-change="contractCurrentChange" :current-page.sync="searchForm.page" :page-size="searchForm.rows" />
      </div>
    </div>
    <!--补录合同-->
    <el-dialog title="补录合同" :visible.sync="contractVisible" :close-on-click-modal="false" append-to-body width="910px" @close="cancel">
      <div-border label="价格设置">
        <div class="nav" style="margin-top: 10px">
          <div class="navContainer" style="width: 300px">
            <p style="width: 100px">不含税金额：</p>
            <el-input v-model.number="condition.price" size="mini" style="width: 150px" placeholder="请输入不含税金额" />
          </div>
          <div class="navContainer">
            <p>含税金额：</p>
            <el-input v-model.number="condition.taxPrice" size="mini" style="width: 150px" placeholder="请输入含税金额" />
          </div>
          <div class="navBtn" style="width: 200px; margin: -30px 0 15px 570px">
            <el-button size="small" class="searchBtn" @click="contractConfirm">确定</el-button>
            <el-button size="small" class="resetBtn" @click="cancel">取消</el-button>
          </div>
        </div>
      </div-border>
      <div-border label="选择合同">
        <el-table
          :data="contractTableData"
          highlight-current-row
          border
          ref="contractTable"
          @current-change="contractChange"
          v-loading="contractLoad"
          style="margin-top: 10px"
          :header-cell-style="{
            color: '#3B3B3B',
            'font-weight': '700',
            padding: '0px',
            'font-size': '13px',
            height: '35px',
            background: '#E8E8E8',
          }"
          :cell-style="{ color: '#7F7F7F', 'font-size': '13px' }">
          <el-table-column type="index" width="50" />
          <el-table-column property="codeNumber" label="合同编号" min-width="150" align="center" />
          <el-table-column property="contractName" label="合同名称" min-width="150" align="center" />
          <el-table-column property="typeName" label="合同类型" min-width="100" align="center" />
          <el-table-column property="companyName" label="签约单位" min-width="150" align="center" />
          <el-table-column property="startDate" label="开始日期" min-width="100" :formatter="getDate" align="center" />
          <el-table-column property="endDate" label="结束日期" min-width="100" :formatter="getDate" align="center" />
        </el-table>
        <div style="margin-top: 20px">
          <el-pagination background :page-sizes="[10, 20, 30, 40]" layout="total, sizes, prev, pager, next, jumper" :total="contractTotal" @size-change="addContractSizeChange" @current-change="addContractCurrentChange" :current-page.sync="page" :page-size="row" />
        </div>
      </div-border>
    </el-dialog>

    <!-- 新增/编辑 -->
    <port-warehouse-expenditure-price-setting-form ref="portWarehouseExpenditurePriceSettingFormRef" @searchBtn="searchBtn" />
    <!-- 详情 -->
    <port-warehouse-expenditure-price-setting-info ref="portWarehouseExpenditurePriceSettingInfoRef" />
    <!-- 完善价格 -->
    <perfect-price ref="perfectPriceRef" @searchBtn="searchBtn" />
  </div>
</template>

<script>
  import PortWarehouseExpenditurePriceSettingForm from '@/views/financial/price/port-warehouse-expenditure-price-setting/components/form';
  import PortWarehouseExpenditurePriceSettingInfo from '@/views/financial/price/port-warehouse-expenditure-price-setting/components/info';
  import PerfectPrice from '@/views/financial/price/port-warehouse-expenditure-price-setting/components/perfect-price';
  import BatchImport from '@/components/batchImport';
  import { formatDateTime, formatTime, getSessionStore } from '@/config/mUtils';
  import { baseUrl } from '@/config/env';
  import { portWarehouseSupplierPriceSettingDelete, portWarehouseSupplierPriceSettingEnableOrDisabled, portWarehouseSupplierPriceSettingList } from '@/service/warehouse';
  import { addContract, getContractPageList } from '@/service/financial';
  import divBorder from '@/components/divBorder.vue';

  export default {
    name: 'portWarehouseExpenditurePriceSetting',
    components: {
      divBorder,
      PortWarehouseExpenditurePriceSettingInfo,
      PortWarehouseExpenditurePriceSettingForm,
      PerfectPrice,
      BatchImport,
    },
    data() {
      return {
        importLoading: false,
        pickerOptions: {
          shortcuts: [
            {
              text: '最近一周',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit('pick', [start, end]);
              },
            },
            {
              text: '最近一个月',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit('pick', [start, end]);
              },
            },
            {
              text: '最近三个月',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                picker.$emit('pick', [start, end]);
              },
            },
          ],
        },
        searchForm: {
          contractType: '',
          createByName: '',
          status: '',
          page: 1,
          rows: 10,
        },
        defaultSearchForm: {},
        tableLoading: false,
        tableData: [],
        headerCellStyle: {
          color: '#3B3B3B',
          'font-size': '13px',
          height: '48px',
          background: '#E8E8E8',
        },
        contractTotal: 0,
        contractLoad: false,
        //总数据条数
        total: 0,
        //当前页数
        page: 1,
        //每页显示多少条数据
        row: 10,
        selectContract: {
          id: '',
          codeNumber: '',
          companyName: '',
          startDate: '',
          endDate: '',
        },
        checkTableData: [],
        contractVisible: false,
        contractTableData: [],
        condition: {
          price: '',
          taxPrice: '',
        },
        settlementTypeOptions: [
          {
            value: 1,
            label: '港口',
          },
          {
            value: 0,
            label: '库房',
          },
        ],
        contractTypeOptions: [
          {
            value: 0,
            label: '合同价',
          },
          {
            value: 1,
            label: '预结算价格',
          },
          {
            value: 2,
            label: '只有预估算价',
          },
        ],
        statusOptions: [
          {
            value: '',
            label: '全部',
          },
          {
            value: '0',
            label: '待生效',
          },
          {
            value: '1',
            label: '生效中',
          },
          {
            value: '2',
            label: '已失效',
          },
        ],
        selectedData: [],
        uploadUrl: '/price/supplier/portAndWarehouse/batchLinePrice',
      };
    },
    mounted() {
      this.defaultSearchForm = JSON.parse(JSON.stringify(this.searchForm));
      this.searchBtn();
    },
    filters: {
      //有效期
      validityDady(val) {
        return formatTime(val, 'yyyy-mm-dd hh:ii:ss');
      },
      getCreatTime(val) {
        if (val) {
          return formatDateTime(val, 'yyyy-mm-dd hh:ii:ss');
        } else {
          return '';
        }
      },
    },
    methods: {
      // 结算类型
      settlementTypeFormat(row, column, cellValue) {
        switch (cellValue) {
          case 0:
            return '库房';
          case 1:
            return '港口';
        }
      },
      // 状态格式化
      statusFormat(row, column, cellValue) {
        switch (cellValue) {
          case 0:
            return '待生效';
          case 1:
            return '生效中';
          case 2:
            return '已失效';
        }
      },
      // 查询
      searchBtn() {
        this.searchForm.page = 1;
        this.getTableData();
      },
      // 重置
      resetBtn() {
        this.searchForm = JSON.parse(JSON.stringify(this.defaultSearchForm));
      },
      // 获取表格数据
      async getTableData() {
        this.tableLoading = true;
        const { status, message, data } = await portWarehouseSupplierPriceSettingList(this.searchForm);
        this.tableLoading = false;
        if (status !== 0) return this.$message.warning(message);
        this.tableData = data.records;
        this.total = data.total;
      },
      // 补录合同
      recordBtn(row) {
        this.condition.id = row.id;
        this.companyId = row.supplierId;
        this.condition.rate = row.taxRate;
        this.contractPrice = row.contractPrice;
        this.preparePrice = row.preparePrice;
        this.startDate = row.startDate;
        this.endDate = row.endDate;
        this.selectContract = '';
        this.getContractPage();
      },
      //查询
      async getContractPage() {
        let obj = {
          id: this.condition.id,
          companyId: this.companyId,
          rate: this.condition.rate,
          contractPrice: this.contractPrice ? this.contractPrice : '',
          preparePrice: this.preparePrice ? this.preparePrice : '',
          page: this.page,
          row: this.row,
        };
        this.contractLoad = true;
        let res = await getContractPageList(obj);
        this.contractLoad = false;
        if (res.status !== 0) {
          this.$message.error(res.message);
          this.contractVisible = false;
        } else {
          this.contractVisible = true;
          this.contractTableData = res.data.records;
          this.contractTotal = res.data.total;
        }
      },
      async contractConfirm() {
        if (!this.condition.price || this.condition.price === '') {
          return this.$message.warning('请输入不含税金额！');
        }
        if (!this.condition.taxPrice || this.condition.taxPrice === '') {
          return this.$message.warning('请输入含税金额！');
        }
        if (!this.selectContract.id || this.selectContract.id === '') {
          return this.$message.warning('请选择合同！');
        }
        let obj = {
          type: 6,
          rate: this.condition.rate,
          taxPrice: this.condition.taxPrice,
          price: this.condition.price,
          priceInfoId: this.condition.id,
          contractId: this.selectContract.id,
          startDate: this.contractTableData[0].startDate ? this.contractTableData[0].startDate : '',
          endDate: this.contractTableData[0].endDate ? this.contractTableData[0].endDate : '',
        };
        const res = await addContract(obj);
        if (res.status !== 0) return this.$message.error(res.message);
        this.$message.success(res.message);
        this.contractVisible = false;
      },
      cancel() {
        this.condition.price = '';
        this.condition.taxPrice = '';
        this.contractVisible = false;
      },
      addContractSizeChange(rows) {
        this.row = rows;
        this.getContractPage();
      },
      addContractCurrentChange(page) {
        this.page = page;
        this.getContractPage();
      },
      contractChange(val) {
        this.selectContract = val;
      },
      // 时间长度处理
      getDate(row, column, cellValue) {
        if (cellValue) {
          return cellValue.substring(0, 10);
        } else {
          return '';
        }
      },
      /**
       * 按钮点击
       * @param str 当前按钮标识
       * @param row 当前选中数据
       */
      btnClick(str, row) {
        switch (str) {
          case 'add':
            this.$refs.portWarehouseExpenditurePriceSettingFormRef.dialogOpen('新增');
            break;
          case 'edit':
            this.$refs.portWarehouseExpenditurePriceSettingFormRef.dialogOpen('修改', row);
            break;
          case 'info':
            this.$refs.portWarehouseExpenditurePriceSettingInfoRef.dialogOpen(row.id);
            break;
          case 'perfectPrice':
            this.$refs.perfectPriceRef.dialogOpen(row);
            break;
          case 'batchEnable':
            if (this.selectedData.length === 0) return this.$message.warning('请选择数据后批量提交');
            const ids = this.selectedData.map(item => item.id).join(',');
            this.enableOrDisabled(ids, str);
            break;
          case 'enable':
            this.enableOrDisabled(row.id, str);
            break;
          case 'disabled':
            this.enableOrDisabled(row.id, str);
            break;
          case 'delete':
            this.deleteData(row.id);
            break;
        }
      },
      /**
       * 删除
       * @param id 当前选中数据 id
       */
      deleteData(id) {
        this.$confirm('确认删除当前数据？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(async () => {
          const { status, message } = await portWarehouseSupplierPriceSettingDelete(id);
          if (status !== 0) return this.$message.warning(message);
          this.$message.success(message);
          await this.getTableData();
        });
      },
      onClickDeletes() {
        if (this.selectedData.length > 0) {
          this.$confirm('确认删除当前选中的数据？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(async () => {
            this.tableLoading = true;
            let ids = '';
            this.selectedData.forEach(rowData => {
              ids = ids + rowData['id'] + ',';
            });
            ids = ids.substring(0, ids.lastIndexOf(','));
            const { status, message } = await portWarehouseSupplierPriceSettingDelete(ids);
            if (status !== 0) {
              this.$message.warning(message);
              this.tableLoading = false;
              return;
            }
            this.$refs.registerTable.clearSelection();
            this.selectedData = [];
            this.$message.success(message);
            await this.getTableData();
          });
        } else {
          this.$message({
            message: '请先选择数据！',
            type: 'warning',
          });
        }
      },
      /**
       * 批量启用/启用/停用
       * @param ids 当前选中数据 id
       * @param str 区分启用停用
       */
      enableOrDisabled(ids, str) {
        this.$confirm(`确认${str === 'disabled' ? '停用' : '启用'}当前选中数据？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(async () => {
          const { status, message } = await portWarehouseSupplierPriceSettingEnableOrDisabled({
            ids,
          });
          if (status !== 0) return this.$message.warning(message);
          this.$message.success(message);
          this.clearCheckTableData();
        });
      },
      onClickStops() {
        if (this.selectedData.length > 0) {
          this.$confirm(`确认停用当前选中数据？`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(async () => {
            this.tableLoading = true;
            const ids = this.selectedData.map(item => item.id).join(',');
            const { status, message } = await portWarehouseSupplierPriceSettingEnableOrDisabled({
              ids,
            });
            if (status !== 0) {
              this.$message.warning(message);
              this.tableLoading = false;
              return;
            }
            // this.$refs.registerTable.clearSelection();
            // this.selectedData = [];
            this.$message.success(message);
            this.clearCheckTableData();
          });
        } else {
          this.$message({
            message: '请先选择要停用的数据！',
            type: 'warning',
          });
        }
      },
      clearCheckTableData() {
        this.$refs.registerTable.clearSelection();
        this.selectedData = [];
        this.getTableData();
      },
      // 导出数据
      exportData() {
        // let token = getSessionStore('token');
        // window.location.href = `${baseUrl}/platform/price/supplier/portAndWarehouse/priceExport?access_token=${token}&supplierName=${this.searchForm.supplierName || ''}&settlementType=${this.searchForm.settlementType || ''}&name=${this.searchForm.name || ''}&contractType=${this.searchForm.contractType || ''}`;
        window.exportExcelGet('/platform/price/supplier/portAndWarehouse/priceExport', `supplierName=${this.searchForm.supplierName || ''}&settlementType=${this.searchForm.settlementType || ''}&name=${this.searchForm.name || ''}&contractType=${this.searchForm.contractType || ''}&taskType=${this.searchForm.taskType || ''}`)
      },
      selectionChange(selectionRow) {
        this.selectedData = selectionRow;
      },
      rowStyle({ row }) {
        return this.selectedData.includes(row) ? { background: 'rgb(197 226 255)' } : {};
      },
      contractSizeChange(row) {
        this.searchForm.rows = row;
        this.searchForm.page = 1;
        this.getTableData();
      },
      contractCurrentChange(page) {
        this.searchForm.page = page;
        this.getTableData();
      },
      download() {
        window.location.href = '/file/港口库房价格设置（支出）模板.xlsx';
      },
    },
  };
</script>

<style lang="scss" scoped>
  .mainContainer {
    width: 100%;
    padding: 20px 15px 0 15px;
    background-color: #fff;

    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      &Btn {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }
    }

    .content {
      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-top: 10px;

        span {
          font-size: 13px;
        }
      }
    }
  }
  .navContainer {
    display: inline-block;
    width: 230px;
    text-align: center;

    p {
      display: inline-block;
      width: 70px;
    }
  }
</style>
